// //@ts-nocheck
import React from 'react';
import { field } from './interfaces';
import {
  Controller,
  ControllerRenderProps,
  FieldValues,
  useFormContext,
} from 'react-hook-form';
import Input from '../atoms/Input';
import { JSXElementConstructor, ReactElement } from 'react';
import InputNumber from '../atoms/InputNumber';
import InputMobile from '../atoms/InputMobile';
import InputOTP from '../atoms/InputOTP';
import TextArea from '../atoms/TextArea';
import CustomDatePicker from '../atoms/CustomDatePicker';
import InputSelect from '../atoms/InputSelect';
import Uploader from '../atoms/Uploader';
import CustomRadio from '../atoms/CustomRadio';
import ChechboxGroup from '../atoms/CheckboxGroup';
import PasswordInput from '../atoms/PasswordInput';
import CustomTimePicker from '../atoms/CustomTimePicker';
import UploadImage from '../atoms/UploadImage';
import Toggle from '../atoms/Toggle';

export default function FormField({
  name,
  id,
  type,
  disableHelperText = false,
  helperText,
  ...rest
}: field) {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const hasError = name
    .split('.')
    .reduce<unknown>(
      (acc, key) =>
        acc && typeof acc === 'object'
          ? (acc as Record<string, unknown>)[key]
          : undefined,
      errors
    );

  const parentName = name.includes('.') ? name.substring(0, name.lastIndexOf('.')) : '';
  const parentError = parentName
    ? parentName
      .split('.')
      .reduce<unknown>(
        (acc, key) =>
          acc && typeof acc === 'object'
            ? (acc as Record<string, unknown>)[key]
            : undefined,
        errors
      )
    : undefined;

  const errorMessage =
    (hasError as { message?: string })?.message ||
    (parentError as { message?: string })?.message;

  const displayHelperText = errorMessage || helperText;

  const Render = ({
    field,
  }: {
    field: ControllerRenderProps<FieldValues, string>;
  }): ReactElement<unknown, string | JSXElementConstructor<unknown>> => {
    switch (type) {
      case 'text':
        return (
          <Input
            status={hasError ? 'error' : undefined}
            helperText={disableHelperText ? undefined : displayHelperText}
            id={id}
            {...field}
            {...rest}
          />
        );
      case 'number':
        return (
          //@ts-expect-error why
          <InputNumber
            status={hasError ? 'error' : undefined}
            helperText={disableHelperText ? undefined : displayHelperText}
            id={id}
            {...field}
            {...rest}
          />
        );
      case 'mobile':
        return (
          <InputMobile
            status={hasError ? 'error' : undefined}
            helperText={disableHelperText ? undefined : displayHelperText}
            id={id}
            {...field}
            {...rest}
          />
        );
      case 'otp':
        return (
          //@ts-expect-error why
          <InputOTP
            status={hasError ? 'error' : undefined}
            helperText={disableHelperText ? undefined : displayHelperText}
            id={id}
            {...field}
            {...rest}
          />
        );
      case 'textarea':
        return (
          <TextArea
            status={hasError ? 'error' : undefined}
            helperText={disableHelperText ? undefined : displayHelperText}
            id={id}
            {...field}
            {...rest}
          />
        );
      case 'date':
        return (
          //@ts-expect-error why
          <CustomDatePicker
            status={hasError ? 'error' : undefined}
            helperText={disableHelperText ? undefined : displayHelperText}
            id={id}
            {...field}
            {...rest}
          />
        );
      case 'time':
        return (
          //@ts-expect-error why
          <CustomTimePicker
            status={hasError ? 'error' : undefined}
            helperText={disableHelperText ? undefined : displayHelperText}
            id={id}
            {...field}
            {...rest}
          />
        );
      case 'file':
        return (
          //@ts-expect-error why
          <Uploader
            id={id}
            // {...field}

            onChangeFile={field.onChange}
            name={field.name}
            status={hasError ? 'error' : undefined}
            helperText={disableHelperText ? undefined : displayHelperText}
            fileList={field.value}
            disabled={field.disabled}
            {...rest}
          />
        );
      case 'uploadImage':
        return (
          <UploadImage
            id={id}
            onChange={field.onChange}
            name={field.name}
            status={hasError ? 'error' : undefined}
            helperText={disableHelperText ? undefined : displayHelperText}
            fileList={field.value}
            disabled={field.disabled}
            {...rest}
          />
        );
      case 'textarea':
        return (
          <TextArea
            status={hasError ? 'error' : undefined}
            helperText={disableHelperText ? undefined : displayHelperText}
            id={id}
            {...field}
            {...rest}
          />
        );
      case 'select':
        return (
          //@ts-expect-error why
          <InputSelect
            status={hasError ? 'error' : undefined}
            helperText={disableHelperText ? undefined : displayHelperText}
            id={id}
            {...field}
            {...rest}
          />
        );
      case 'checkBox':
        return (
          //@ts-expect-error why
          <ChechboxGroup
            status={hasError ? 'error' : undefined}
            helperText={disableHelperText ? undefined : displayHelperText}
            {...field}
            {...rest}
          />
        );
      case 'radio':
        return (
          //@ts-expect-error why
          <CustomRadio
            status={hasError ? 'error' : undefined}
            helperText={disableHelperText ? undefined : displayHelperText}
            id={id}
            {...field}
            {...rest}
          />
        );
      case 'password':
        return (
          //@ts-expect-error why
          <PasswordInput
            status={hasError ? 'error' : undefined}
            helperText={disableHelperText ? undefined : displayHelperText}
            id={id}
            {...field}
            {...rest}
          />
        );
      case 'toggle':
        return (
          <Toggle
            status={hasError ? 'error' : undefined}
            helperText={disableHelperText ? undefined : displayHelperText}
            id={id}
            checked={field.value || false}
            onChange={field.onChange}
            disabled={rest.disabled}
            {...rest}
          />
        );
      default:
        return (
          <Input
            status={hasError ? 'error' : undefined}
            helperText={disableHelperText ? undefined : displayHelperText}
            id={id}
            type={type}
            {...field}
            {...rest}
          />
        );
    }
  };

  return (
    <Controller
      control={control}
      name={name}
      // {...register(name)}
      render={({ field }) => Render({ field })}
    />
  );
}
